import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function VideoBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section ref={ref} className="relative w-full h-[95vh] min-h-[520px] overflow-hidden border-y border-white/5" data-testid="video-band">
      <motion.video
        style={{ scale, y }}
        className="absolute inset-0 w-full h-full object-cover"
        src="/videos/intro.mp4"
        autoPlay loop muted playsInline preload="auto"
        data-testid="video-band-video"
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, rgba(5,5,5,0.7), rgba(5,5,5,0.25) 40%, rgba(5,5,5,0.85))" }} />
      <div className="relative z-[2] h-full flex flex-col items-center justify-center text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1 }}
          className="max-w-4xl"
        >
          <div className="overline mb-5">Highly Skilled Professionals</div>
          <h2 className="font-display font-light text-3xl sm:text-5xl lg:text-6xl text-white leading-tight">
            A team that treats every home like a <span className="gold-fill italic">work of art.</span>
          </h2>
          <p className="mt-6 text-[var(--text-2)] max-w-2xl mx-auto text-base leading-relaxed">
            From the first sketch to the final finish, Crown Artisan Design brings together master craftsmen, designers, and builders under one roof — obsessed with the details most never notice, but everyone feels.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
